export enum ReceiptStatus {
  IS_RECEIPT = 'IS_RECEIPT',
  WAS_RECEIPT = 'WAS_RECEIPT',
}
